export const TREND_POINTS = [20, 35, 28, 45, 38, 55, 48, 62, 58, 70];

/* Never show 0.X — use K/M appropriately. */
export const formatRevenue = (amount) => {
  if (amount >= 1000000) {
    const m = amount / 1000000;
    return m % 1 === 0 ? `$${m.toFixed(0)}M` : `$${m.toFixed(1)}M`;
  }
  if (amount >= 1000) return `$${(amount / 1000).toFixed(0)}K`;
  return `$${amount.toFixed(0)}`;
};

export const daysRemainingUntil = (goalEndDate) => {
  if (!goalEndDate) return null;
  const endDate = new Date(goalEndDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  return Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};

export const formatGoalDate = (dateStr) => (dateStr ? new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : null);

export const countdownColor = (days) => {
  if (days === null) return "text-gray-400";
  if (days <= 30) return "text-red-400";
  if (days <= 90) return "text-yellow-400";
  return "text-ism-teal";
};

export const countdownLabel = (days) => {
  if (days === null) return "No deadline set";
  if (days < 0) return `${Math.abs(days)} days overdue`;
  if (days === 0) return "Due today!";
  return `${days} days left`;
};

export const trendPath = (points, close = false) => {
  const max = Math.max(...points);
  const pt = (val, idx) => `${(idx / (points.length - 1)) * 300} ${120 - (val / max) * 100}`;
  const line = `M ${pt(points[0], 0)} ${points.map((v, i) => `L ${pt(v, i)}`).join(" ")}`;
  return close ? `${line} L 300 120 L 0 120 Z` : line;
};

export const trendPoint = (points, idx) => {
  const max = Math.max(...points);
  return { cx: (idx / (points.length - 1)) * 300, cy: 120 - (points[idx] / max) * 100 };
};
